import DocumentIllustration from "components/DocumentIllustration";
import VerifyDatabaseDocument from "components/VerifyDatabaseDocument";
import { useContext, useState } from "react";
import IDTrackerPricing from "features/breaches/pages/IDTrackerPricing";
import { UserContext } from "features/account";
import Button from "shared/ui/Button";
import { Button_Style, Button_Type } from "shared/ui/Button/Button";
import { sendBroadcastEmail } from "features/sponsorship";

export default function DatabaseDocuments() {
    const [type, setType] = useState<string>("");
    const [verificationDone, setVerificationDone] = useState<boolean>(false);
    const { user, userType } = useContext(UserContext);
    const clientType = user?.type ?? 'individual';

    // Check if email contains @leasys
    const isLeasys = user?.email?.toLowerCase().includes('@leasys') || false;
    const isLeasingFactory = user?.email?.toLowerCase().includes('@ca-lf') || false;

    const handleChangeType = (type: string) => {
        setType(type);
    };

    const handleBroadcast = () => {
        console.log("handleBroadcast");
        const response = sendBroadcastEmail();
        console.log(response);
    };

    // Determine if Trustfull verification should be shown
    const shouldShowTrustfullVerification = () => {
        const forAdv = !(process.env.REACT_APP_FOR_ADV === '1' || process.env.REACT_APP_FOR_ADV === 'true');
        return forAdv && !isLeasys;
    };

    return (
      <div className="content__body">
          <div className="row align-items-center">
              <div className={`${verificationDone ? 'col-sm-5' : 'col-sm-6'}`}>
                  <div className="card">
                      <VerifyDatabaseDocument
                        type={type}
                        setType={handleChangeType}
                        setVerificationDone={setVerificationDone}
                        verificationDone={verificationDone}
                        showTrusfullVerification={shouldShowTrustfullVerification()}
                        hideBirthFields={isLeasingFactory}
                      />
                  </div>
              </div>
              <div
                className={`${verificationDone ? 'col-sm-7' : 'col-sm-6'} d-flex justify-content-center align-items-center`}
              >
                  {(!verificationDone || userType === 'partner') && (
                    <DocumentIllustration type={type} />
                  )}

                  {verificationDone && clientType !== 'partner' && (
                    <IDTrackerPricing isPage={false}/>
                  )}
              </div>
          </div>
      </div>
    );
}